export default "__VITE_ASSET__5602f258__"